import axios from 'axios'
import { SAVINGS_PLAN_SUBSCRIPTION_ENDPOINT } from 'cfgCommon/endpoints'

export async function postDmsIntegration(data, isRetry = false) {
    const response = await axios.post(
        `${SAVINGS_PLAN_SUBSCRIPTION_ENDPOINT}/informar`,
        { ...data, isRetry}
    )
    return response.data
}
